import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LessonsComponent } from './components/lessons.component';
import { ComponentIframe } from './components/iframe.component';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [LessonsComponent, ComponentIframe ]
})
export class LessonsModule { }



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/lessons/lessons.module.ts